import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-property",
  "use": "icon-property-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-property\"><defs><style type=\"text/css\"></style></defs><path d=\"M708.608 332.8V51.2H36.608v953.6h672zM276.736 628.992h-64v-108.8h64z m0-299.52h-64V220.672h64z m179.2 133.888v-108.8h64v108.8zM772.608 357.376v647.424h236.8v-555.52l-236.8-91.904z\" p-id=\"4871\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol